import { api } from './client';

export interface ManagedJob {
  id: string;
  name: string;
  description: string;
  expression: string;
  command: string;
  user: string;
  active: boolean;
  createdAt: string;
  updatedAt: string;
  source: 'webadmin';
}

export interface SystemJob {
  id: string;
  name: null;
  description: null;
  expression: string;
  command: string;
  user: string;
  active: boolean;
  source: 'system';
}

export type CronJob = ManagedJob | SystemJob;

export interface CronBackup {
  filename: string;
  createdAt: string;
  jobCount: number;
}

export interface CreateJobPayload {
  name: string;
  description?: string;
  expression: string;
  command: string;
  user?: string;
}

export const getJobs = (): Promise<{ jobs: CronJob[] }> =>
  api.get<{ jobs: CronJob[] }>('/cron/jobs').then((r) => r.data);

export const createJob = (data: CreateJobPayload): Promise<{ job: ManagedJob }> =>
  api.post<{ job: ManagedJob }>('/cron/jobs', data).then((r) => r.data);

export const toggleJob = (id: string): Promise<{ job: ManagedJob }> =>
  api.patch<{ job: ManagedJob }>(`/cron/jobs/${id}/toggle`).then((r) => r.data);

export const deleteJob = (id: string): Promise<{ ok: boolean }> =>
  api.delete<{ ok: boolean }>(`/cron/jobs/${id}`).then((r) => r.data);

export interface PreviewResult {
  success: true;
  runs: string[];
}

export const previewCron = (expression: string, count = 5): Promise<PreviewResult | { success: false; error: string }> =>
  api.get('/cron/preview', { params: { expression, count } }).then((r) => r.data);

export const exportJobs = (): Promise<Blob> =>
  api.get('/cron/export', { responseType: 'blob' }).then((r) => r.data as Blob);

export const importJobs = (jobs: ManagedJob[], mode: 'merge' | 'replace'): Promise<{ imported: number; skipped: number }> =>
  api.post<{ imported: number; skipped: number }>('/cron/import', { jobs, mode }).then((r) => r.data);

export const listBackups = (): Promise<{ backups: CronBackup[] }> =>
  api.get<{ backups: CronBackup[] }>('/cron/backups').then((r) => r.data);

export const createBackup = (): Promise<{ filename: string }> =>
  api.post<{ filename: string }>('/cron/backups').then((r) => r.data);

export const restoreBackup = (filename: string): Promise<{ imported: number; skipped: number }> =>
  api.post<{ imported: number; skipped: number }>(`/cron/backups/${encodeURIComponent(filename)}/restore`).then((r) => r.data);

export const deleteBackup = (filename: string): Promise<{ ok: boolean }> =>
  api.delete<{ ok: boolean }>(`/cron/backups/${encodeURIComponent(filename)}`).then((r) => r.data);
